import { render } from "./Absences.vue?vue&type=template&id=608fb076"
import script from "./Absences.vue?vue&type=script&lang=js"
export * from "./Absences.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__